<script>
  import GroupSelect from '@/components/GroupSelect/index.vue';
  import { addAffiliateBilling, updateAffiliateBilling } from 'api/billing/affiliateBilling';

  export default {
    name: 'AffiliateBillingBaseForm',
    components: { GroupSelect },
    computed: {},
    props: {
      affiliatesGroupList: {
        type: Array,
        default: () => {
          return [];
        },
      },
      allAmList: {
        type: Array,
        default: () => {
          return [];
        },
      },
      allBdList: {
        type: Array,
        default: () => {
          return [];
        },
      },
      affPaymentTypeList: {
        type: Array,
        default: () => {
          return [];
        },
      },
      dialogType: {
        type: String,
        default: 'new',
      },
      affHedgeAppPaymentStatusList: {
        type: Array,
        default: () => {
          return [];
        },
      },
      reconciliationProgressList: {
        type: Array,
        default: () => {
          return [];
        },
      },
      paymentRequestStatusList: {
        type: Array,
        default: () => {
          return [];
        },
      },
      affPaymentMergeStatusList: {
        type: Array,
        default: () => {
          return [];
        },
      },
      dialogVisible: {
        type: Boolean,
        default: false,
      },
      editData: {
        type: Object,
        default: () => {
          return {};
        },
      },
      affCompanyEntityList: {
        type: Array,
        default: () => {
          return [];
        },
      },
    },
    data() {
      return {
        formData: {},
        rules: {},
        companyEntityList: [],
        companyPlatformList: [],
        inputs: [{ value: '' }],
        formProcessing: false,
      };
    },
    watch: {
      editData: {
        handler(newVal) {
          this.formData = Object.assign({}, newVal);
          let remarks = [];
          if (this.formData.remark !== null && this.formData.remark !== undefined) {
            remarks = [...this.formData.remark];
          }
          let remarkTemp = remarks.map((item) => ({ value: item }));
          if (remarkTemp.length === 0) {
            this.inputs = [{ value: '' }];
          } else {
            this.inputs = remarkTemp;
          }
          this.companyPlatformList.length = 0;
          this.companyEntityList.length = 0;
          for (let i = 0; i < this.affCompanyEntityList.length; i++) {
            this.companyPlatformList.push(this.affCompanyEntityList[i].companyPlatform);
            if (i === 0) {
              this.companyEntityList = [...this.affCompanyEntityList[i].companyEntityList];
            }
          }
        },
      },
      dialogVisible(newVal) {
        if (!newVal) {
          this.$refs.baseForm.resetFields();
        } else {
          if (this.$refs.baseForm) {
            this.$refs.baseForm.clearValidate();
          }
        }
      },
    },
    mounted() {},
    methods: {
      handleSubmit() {
        this.$refs.baseForm.validate((valid) => {
          if (valid) {
            this.formProcessing = true;
            try {
              this.formData.affName = this.getAffName(this.formData.affId);
              this.formData.amName = this.getAmName(this.formData.amId);
              this.formData.bdName = this.getBdName(this.formData.bdId);
              this.formData.remark = this.joinedString();
              if (this.dialogType === 'new') {
                addAffiliateBilling({ ...this.formData }).then(() => {
                  this.$message({
                    message: 'Add Success',
                    type: 'success',
                  });
                  this.$emit('refresh-list');
                  this.handleClose();
                });
              } else if (this.dialogType === 'edit') {
                updateAffiliateBilling({ ...this.formData }).then(() => {
                  this.$message({
                    message: 'Update Success',
                    type: 'success',
                  });
                  this.$emit('refresh-list');
                  this.handleClose();
                });
              }
            } finally {
              setTimeout(() => {
                this.formProcessing = false;
              }, 500);
            }
          } else {
            return false;
          }
        });
      },
      handleClose() {
        this.$emit('update:dialogVisible', false);
      },
      getAmName(amId) {
        if (amId === null || amId === undefined) {
          return undefined;
        }
        return this.allAmList.find((item) => item.value === amId)?.label || undefined;
      },
      getBdName(bdId) {
        if (bdId === null || bdId === undefined) {
          return undefined;
        }
        return this.allBdList.find((item) => item.value === bdId)?.label || undefined;
      },
      getAffName(affId) {
        if (affId === null || affId === undefined) {
          return '';
        }
        for (let i = 0; i < this.affiliatesGroupList.length; i++) {
          for (let j = 0; j < this.affiliatesGroupList[i].children.length; j++) {
            if (this.affiliatesGroupList[i].children[j].id === affId) {
              return this.affiliatesGroupList[i].children[j].label.replace(affId + ' - ', '');
            }
          }
        }
      },
      addInput() {
        this.inputs.push({ value: '' });
      },
      removeInput(index) {
        if (this.inputs.length > 0) {
          this.inputs.splice(index, 1);
        }
      },
      joinedString() {
        return this.inputs.filter((input) => input.value !== '').map((input) => input.value);
      },
      handleCompanyEntity(value) {
        if (value === '') {
          return;
        }
        this.companyEntityList.length = 0;
        this.formData.affEntity = null;
        this.companyEntityList = [
          ...this.affCompanyEntityList.find((item) => item.companyPlatform === value)
            .companyEntityList,
        ];
      },
    },
  };
</script>

<template>
  <el-dialog
    :title="dialogType === 'new' ? 'Affiliate Billing Create' : 'Affiliate Billing Update'"
    :visible="dialogVisible"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <el-form
      label-position="left"
      label-width="180px"
      ref="baseForm"
      :model="formData"
      :rules="rules"
      :disabled="formProcessing"
      class="grid-form"
    >
      <el-form-item label="Date" prop="recordDate" v-if="formData.id === undefined" required>
        <el-date-picker v-model="formData.recordDate" value-format="yyyy-MM" type="month" />
      </el-form-item>
      <el-form-item label="Business Module" v-if="formData.id === undefined" prop="businessModule">
        <el-input v-model="formData.businessModule" placeholder="please input" />
      </el-form-item>
      <el-form-item
        label="Aff Company Platform"
        v-if="formData.id === undefined"
        prop="affCompanyPlatform"
      >
        <el-select
          v-model="formData.affCompanyPlatform"
          filterable
          clearable
          placeholder="please select"
          @change="handleCompanyEntity"
        >
          <el-option v-for="item in companyPlatformList" :key="item" :label="item" :value="item" />
        </el-select>
      </el-form-item>
      <el-form-item label="Aff Entity" v-if="formData.id === undefined" prop="affEntity">
        <el-select v-model="formData.affEntity" filterable clearable placeholder="please select">
          <el-option v-for="item in companyEntityList" :key="item" :label="item" :value="item" />
        </el-select>
      </el-form-item>
      <el-form-item label="Affiliate" prop="affId" required>
        <group-select
          :disabled="formData.id !== undefined"
          v-model="formData.affId"
          :data-source="affiliatesGroupList"
          clearable
          filterable
          reserve-keyword
          placeholder="please select"
        />
      </el-form-item>
      <el-form-item label="BD" prop="bdId" v-if="formData.id === undefined">
        <el-select v-model="formData.bdId" filterable clearable>
          <el-option
            v-for="item in allBdList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="AM" prop="amId" v-if="formData.id === undefined">
        <el-select v-model="formData.amId" filterable clearable>
          <el-option
            v-for="item in allAmList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="Aff Revenue" prop="affRevenue" v-if="formData.id === undefined">
        <el-input v-model="formData.affRevenue" placeholder="please input" />
      </el-form-item>
      <el-form-item
        label="Aff Confirmed Amount"
        prop="affConfirmedAmount"
        v-if="formData.id === undefined"
      >
        <el-input v-model="formData.affConfirmedAmount" placeholder="please input" />
      </el-form-item>
      <el-form-item label="Payment Status" prop="paymentStatus" v-if="formData.id === undefined">
        <el-select
          v-model="formData.paymentStatus"
          filterable
          clearable
          placeholder="please select"
        >
          <el-option
            v-for="item in affHedgeAppPaymentStatusList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="Hedge Amount" prop="hedgeAmount" v-if="formData.id === undefined">
        <el-input v-model="formData.hedgeAmount" type="number" placeholder="please input" />
      </el-form-item>
      <el-form-item label="Payment Amount" prop="paymentAmount" v-if="formData.id === undefined">
        <el-input v-model="formData.paymentAmount" type="number" placeholder="please input" />
      </el-form-item>

      <el-form-item label="Checked Time" prop="checkedTime">
        <el-date-picker
          v-model="formData.checkedTime"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="选择日期时间"
        />
      </el-form-item>
      <el-form-item
        label="Reconciliation Progress"
        prop="reconciliationProgress"
        v-if="formData.id === undefined"
      >
        <el-select
          v-model="formData.reconciliationProgress"
          filterable
          clearable
          placeholder="please select"
        >
          <el-option
            v-for="item in reconciliationProgressList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        label="Payment Request Status"
        prop="paymentRequestStatus"
        v-if="formData.id === undefined"
      >
        <el-select
          v-model="formData.paymentRequestStatus"
          filterable
          clearable
          placeholder="please select"
        >
          <el-option
            v-for="item in paymentRequestStatusList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        label="Payment Merge Status"
        prop="paymentMergeStatus"
        v-if="formData.id === undefined"
      >
        <el-select
          v-model="formData.paymentMergeStatus"
          filterable
          clearable
          placeholder="please select"
        >
          <el-option
            v-for="item in affPaymentMergeStatusList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="Remark" prop="remark">
        <el-button @click="addInput" type="primary" size="small">Add</el-button>
        <div v-for="(input, index) in inputs" :key="index" style="margin-top: 10px">
          <el-row>
            <el-input
              v-model="input.value"
              style="width: 230px;margin-right: 10px"
              placeholder="please input"
            ></el-input>
            <el-button
              type="danger"
              icon="el-icon-delete"
              @click="removeInput(index)"
              circle
            ></el-button>
          </el-row>
        </div>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" :disabled="formProcessing" @click="handleSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<style scoped lang="scss"></style>
